var _style, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLhwsCtv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:url(#SVGID_1_);stroke:#ADB4CC;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_00000037657527985263022620000016000874088026357888_);}\n\t.st3{fill:#7289AD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Color_Blocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.95,
    y1: 670.4606,
    x2: 34.95,
    y2: 756.332,
    gradientTransform: "matrix(1 0 0 1 0 -679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#CAE7F5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.1,69H9.9c-5,0-9.1-4.1-9.1-9.1V10.1C0.9,5,4.9,1,9.9,1H60c5,0,9.1,4.1,9.1,9.1V60 C69.1,65,65.1,69,60.1,69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040554653310565161650000008943219509974560697_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.2639,
    y1: 696.05,
    x2: 77.8368,
    y2: 696.05,
    gradientTransform: "matrix(1 0 0 1 0 -679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9986,
    style: {
      stopColor: "#F2F2F3",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040554653310565161650000008943219509974560697_)"
    },
    d: "M35,24.3c12.1,0,23.6,3,33.6,8.2V10.1 c0-4.7-3.8-8.6-8.6-8.6H9.9c-4.7,0-8.6,3.8-8.6,8.6v22.5C11.4,27.3,22.9,24.3,35,24.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Original_Icons",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.1,14.3H12.9c-1.8,0-3.2,1.4-3.2,3.2v26c0,1.8,1.4,3.2,3.2,3.2h20.6v4.1h-9.6c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5h22.3c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-9.6v-4.1h20.6c1.8,0,3.2-1.4,3.2-3.2v-26 C60.3,15.7,58.9,14.3,57.1,14.3z M57.3,43.4c0,0.1-0.1,0.2-0.2,0.2H12.9c-0.1,0-0.2-0.1-0.2-0.2v-26c0-0.1,0.1-0.2,0.2-0.2h44.2 c0.1,0,0.2,0.1,0.2,0.2V43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35,34.4c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9S36.1,34.4,35,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.1,31.9c-3.5-3.1-8.7-3.1-12.2,0c-0.2,0.2-0.2,0.5,0,0.7c0,0,0,0,0,0l1,1c0.2,0.2,0.5,0.2,0.7,0 c2.5-2.2,6.3-2.2,8.8,0c0.2,0.2,0.5,0.2,0.7,0l1-1C41.3,32.4,41.3,32.1,41.1,31.9C41.1,31.9,41.1,31.9,41.1,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.5,28.4L44.5,28.4c-5.4-4.9-13.6-4.9-18.9,0c-0.2,0.2-0.2,0.5,0,0.7c0,0,0,0,0,0l1,1c0.2,0.2,0.5,0.2,0.7,0 c4.4-4,11.1-4,15.6,0c0.2,0.2,0.5,0.2,0.7,0l1-1C44.7,29,44.7,28.7,44.5,28.4C44.5,28.5,44.5,28.5,44.5,28.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhwsCtv);
export default __webpack_public_path__ + "static/media/lhws-ctv.a44708bd5e8501138b59d21c9e135c4d.svg";
export { ForwardRef as ReactComponent };